export default {
  baseShapeData: {
    baseShape: undefined,
    orderable: undefined,
    products: undefined
  },
  baseShapePriceData: {
    baseShape: undefined,
    length: undefined,
    messages: undefined,
    price: undefined,
    products: undefined
  },
  checkoutAttachments: [],
  countriesWithStates: undefined,
  numberOfItemsInShoppingCart: undefined,
  paymentMethods: undefined,
  servicePartners: undefined,
  shippingAddresses: {
    companyAddresses: undefined,
    customerAddresses: undefined
  },
  shoppingCart: {
    additionalCosts: undefined,
    additionalCosts2: undefined,
    baseShapes: undefined,
    messages: undefined,
    orderable: undefined,
    productsSubtotal: undefined,
    requestedDeliveryDate: undefined,
    shoppingCartId: undefined,
    subtotal: undefined,
    totalPrice: undefined,
    vat: undefined,
    // checkout data
    additionalInfo: undefined,
    billingAddress: undefined,
    checkoutType: undefined,
    paymentMethod: undefined,
    promoCodes: undefined,
    shippingAddress: undefined,
    shippingMethod: undefined,
    sp: undefined,
    spSelectionRequired: undefined,
    transportMethod: undefined,
    transportMethodSelectionRequired: undefined,
    vouchers: undefined
  },
  shoppingCartLastRefreshedTimestamp: undefined,
  transportMethods: undefined,
  paymentSuccessURL: undefined
};
